import { render, staticRenderFns } from "./HealthQuestionnaire1.vue?vue&type=template&id=f8632df2"
import script from "./HealthQuestionnaire1.vue?vue&type=script&lang=js"
export * from "./HealthQuestionnaire1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports